import { action } from 'typesafe-actions';
import {
  PREMIUMINFO_FAILURE,
  PREMIUMINFO_REQUEST,
  PUBLICPREMIUMINFO_REQUEST,
  PREMIUMINFO_SUCCESS,
  PREMIUM_PRICING_TIERS_REQUEST,
  PREMIUM_PRICING_TIERS_SUCCESS,
  PREMIUM_PRICING_TIERS_FAILURE,
} from '../../constants/premium';

export const premiumInfoRequestAction = (tipster_id: string) =>
  action(PREMIUMINFO_REQUEST, tipster_id);
export const publicPremiumInfoRequestAction = (tipster_id: string) => {
  return action(PUBLICPREMIUMINFO_REQUEST, { tipster_id });
};
export const premiumInfoSuccessAction = (data: any) =>
  action(PREMIUMINFO_SUCCESS, data);
export const premiumInfoFailureAction = (e: any) =>
  action(PREMIUMINFO_FAILURE, e);

export const premiumPricingTiersRequestAction = () =>
  action(PREMIUM_PRICING_TIERS_REQUEST);
export const premiumPricingTiersSuccessAction = (data: any) =>
  action(PREMIUM_PRICING_TIERS_SUCCESS, data);
export const premiumPricingTiersFailureAction = (e: any) =>
  action(PREMIUM_PRICING_TIERS_FAILURE, e);

export const premiumInfoActions = {
  premiumInfoRequestAction,
  publicPremiumInfoRequestAction,
  premiumInfoSuccessAction,
  premiumInfoFailureAction,
  premiumPricingTiersRequestAction,
  premiumPricingTiersSuccessAction,
  premiumPricingTiersFailureAction,
};
